import React from "react";
import { Col, Container, Row } from "reactstrap";

const Demofooter = () => {
  return (
    <div className='bg-light'>
      <Container>
        <Row>
          <Col md={12}>
            <div className='Copyright-section'>
              <p>2018- 19 Copyright &copy; powered by Pixelstrap</p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Demofooter;
